import React, { Component } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { withStyles } from '@mui/material/styles';
import DollarIcon from '@mui/icons-material/AttachMoney';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import { translate } from 'react-admin';
import { Title } from 'react-admin';
import { Link } from "react-router-dom";
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption, Papa } from '../common/common';
import { stringify } from 'query-string';
import { CREATE  } from 'react-admin';
import { VerifiedData } from './component/verified_data/verified_data';
import { OnboardingReport } from './component/onboarding_report/onboarding_report'
const apiUrl = RUN_TIME_API_ENDPOINT;
const options = CommonHeaderOption();
export default class Onboard extends Component {

    constructor(props) {
        super(props);
        this.uploadRetailers = this.uploadRetailers.bind(this);
    }
    state = {
        verifiedData: {
            unique_retailers: [],
            retailers_to_onboard: [],
            unique_onboarding_retailer: [],
        },
        onboardedRetailer: {
            onboarded_retailers_count: 0,
            retailers_unable_to_board: [],
            updated_retailers: [],
            new_retailers: [],
        },
        alreadyRegistered: 0,
        readyToOnboard: 0,
        verifyDataFlag: false,
        onboardReportFlag: false,
        loadingShow: false,
    }

    componentWillMount(){
       // this.getStatsData();
    }

    getStatsData = () =>{
        const options = CommonHeaderOption();
        const apiUrl = RUN_TIME_API_ENDPOINT;
        fetch(`${apiUrl}/dashboard_stats`, options)
        .then(res => {
            return res.json();
        })
        .then(json => {
            this.setState({stats_data: json.data});
        });
    }
    CheckData = () => {
        const fileObj = document.getElementById("file");
        const checkIfFileIsPresent = !document.getElementById("file").value;
        if(!checkIfFileIsPresent)
        {
            Papa.parse(fileObj.files[0], {
                header: true,
                dynamicTyping: true,
                complete: this.postOnboardingDataToVerify
            });
        } else {
            alert ('please select file')
        }
  
    }

    
    postOnboardingDataToVerify = (results) => {
        options.body = JSON.stringify({onboarding_data: [...results.data]});
        options.method = 'POST';
        this.setState({
            loadingShow: true,
        });
        fetch(`${apiUrl}/verifyretailers`, options)
        .then(res => {
            return res.json();
        })
        .then(json => {
            this.checkUniqueDataFlag(json.unique_retailers);
            this.setState({
                verifiedData: {
                    ...this.state.verifiedData,
                    existing_retailer: json.existing_retailer,
                    unique_retailers: json.unique_retailers,
                    verified_retailers: json.verified_retailers,
                    retailers_to_onboard: json.retailers_to_onboard,
                },
                verifyDataFlag: true,
                loadingShow: false,
            });
        });
    }

    uploadRetailers(retailerData){
        const { state } = this
        options.body = JSON.stringify({onboarding_data: retailerData});
        options.method = 'POST';

        this.setState({
            loadingShow: true,
        });
        fetch(`${apiUrl}/onboardretailercsv`, options)
        .then(res => {
            return res.json();
        })
        .then(json => {
            this.setState({
                onboardedRetailer: {
                    ...this.state.onboardedRetailer,
                    onboarded_retailers_count: json.onboarded_retailer,
                    retailers_unable_to_board: json.retailers_unable_to_board,
                    updated_retailers: json.updated_retailers,
                    new_retailers: json.new_retailers,
                },
                verifyDataFlag: false,
                onboardReportFlag:true,
                loadingShow: false,
            });
        });
    }

    checkUniqueDataFlag(retailerData){
        let alreadyRegistered = 0, readyToOnboard = 0;
        let readyToOnboardRetailers = [];
        retailerData.forEach(element => {   
            if(element.isArleadyRegistered) {
                alreadyRegistered += 1;
            } else {
                readyToOnboardRetailers.push(element);
                readyToOnboard += 1; 
            }
        });
        this.setState({
            verifiedData: {
                ...this.state.VerifiedData,
                unique_onboarding_retailer: readyToOnboardRetailers,
            },
            alreadyRegistered: alreadyRegistered,
            readyToOnboard: readyToOnboard,
        });
    }

    render() {
        const { state } = this;
        return (
            <div>
            {   this.state.loadingShow &&
                <div className="custom-loader"><CircularProgress /></div>
            }
            {   !this.state.verifyDataFlag && !this.state.onboardReportFlag &&
            <Card className="welcom_container">
            <center><Title title="Onboard" /></center>
                <CardContent>
                   <p>Select File</p>
                   <input className="common-button" type="file" id="file" accept=".csv" /><br/><br/>
                   <button className="common-button" onClick={this.CheckData}>Upload &amp; Verify File</button>
                </CardContent>
            </Card>
            }
            {   this.state.verifyDataFlag &&
                <VerifiedData 
                    data={this.state.verifiedData}
                    alreadyRegistered={this.state.alreadyRegistered}
                    readyToOnboard={this.state.readyToOnboard}
                    uploadRetailers={this.uploadRetailers}
                />
            }
            {
                this.state.onboardReportFlag &&
                <OnboardingReport 
                    data={this.state.onboardedRetailer}
                />
            }
            </div>
         );
    }
}
